<template>
  <v-layout row wrap style="padding-left:10px; padding-right:10px;">
    <v-flex xs12 md6>
      <v-layout :row="$vuetify.breakpoint.mdAndUp" :column="!$vuetify.breakpoint.mdAndUp">
        <v-flex xs12 md5>
          <v-select
            v-if="isGroupsView"
            outline
            background-color="primary"
            v-model="selectedGroup"
            :items="group"
            :label="$t('page.schedules.company-group')"
            hide-details
            single-line
            item-text="name"
            item-value="_id"
            solo
            prepend-inner-icon="mdi-home-variant"
            @change="changedGroup"
          ></v-select>
        </v-flex>
        <v-flex xs12 md5>
          <v-select
            v-if="isBuildingsView"
            outline
            background-color="primary"
            v-model="selectedBuilding"
            :items="building"
            :label="$t('page.schedules.building')"
            hide-details
            single-line
            item-text="name"
            item-value="_id"
            solo
            prepend-inner-icon="mdi-office-building"
            @change="changedBuilding"
          ></v-select>
        </v-flex>
        <v-flex xs12 md5>
          <v-select
            v-if="isFloorView"
            outline
            background-color="primary"
            style="border-radius: 8px !important;"
            v-model="selectedFloor"
            :items="floor"
            :label="$t('page.schedules.floor')"
            hide-details
            single-line
            item-text="name"
            item-value="floor"
            solo
            prepend-inner-icon="mdi-floor-plan"
            @change="changedFloor"
          ></v-select>
        </v-flex>
      </v-layout>
    </v-flex>
    <!-- <v-flex lg2 sm4 xs6>
      <v-select
        v-model="selectedRooms"
        :items="rooms"
        :label="$t('page.schedules.room')"
        item-text="name"
        item-value="_id"
        solo
        multiple
        prepend-inner-icon="mdi-door-open"
        @change="changedRooms"
      ></v-select>
    </v-flex> -->
    <div v-if="viewType === 'calendar'" class="reserve-btn" @click="reserveMeeting" style="width:120px; font-size:15px; margin-top:2px;">
      {{ $t('page.my-meeting.meeting-reserve') }}
    </div>
    <v-spacer/>
    <v-flex v-if="viewType === 'table'" md5 xs12> 
      <v-layout :row="$vuetify.breakpoint.mdAndUp" :column="!$vuetify.breakpoint.mdAndUp">
        <v-flex xs12 md5>
          <v-select
            outline
            background-color="primary"
            v-model="selectedCustomType"
            :items="customTypeList"
            :label="$t('page.meeting-reserve.custom-meeting-type')"
            hide-details
            single-line
            item-text="name"
            item-value="value"
            solo
            prepend-inner-icon="mdi-floor-plan"
            @change="changedCustomType"
          ></v-select>
        </v-flex>
        <v-flex md4 xs12>
          <v-menu
            ref="menu"
            background-color="primary"
            lazy
            :close-on-content-click="false"
            v-model="menu"
            transition="scale-transition"
            offset-y
            full-width
            :nudge-right="40"
            min-width="290px"
            color="pink"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                background-color="primary"
                slot="activator"
                placeholder="From"
                v-model="startDate"
                height="37px"
                color="pink"
                readonly
                outline
                single-line
                hide-details
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker 
              v-model="startDate" 
              no-title 
              scrollable
              :allowed-dates="allowedStartDates"
              @input="menu = false"
            />
          </v-menu>
        </v-flex>
        <span style="margin-top:14px;">~</span>
        <v-flex md4 xs12>
          <v-menu
              ref="menu1"
              background-color="primary"
              lazy
              :close-on-content-click="false"
              v-model="menu1"
              transition="scale-transition"
              offset-y
              full-width
              :nudge-right="40"
              min-width="290px"
              color="pink"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                background-color="primary"
                slot="activator"
                placeholder="To"
                v-model="endDate"
                height="37px"
                readonly
                outline
                single-line
                hide-details
                color="pink"
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker 
              v-model="endDate" 
              no-title 
              scrollable
              :allowed-dates="allowedEndDates"
              color="pink"
              @input="menu1 = false"
            />
          </v-menu>
        </v-flex>
      </v-layout>
    </v-flex>
    <!-- <v-btn color="primary" class="mt-2" large @click="addImmediateMeeting">
      <v-icon>mdi-account-alert-outline</v-icon>&nbsp;&nbsp;{{ $t('page.my-meeting.immediate-reserve') }}
    </v-btn> -->
    
    <!-- <v-btn color="secondary" class="mt-1" @click="reserveMeeting">
      <v-icon>mdi-google-classroom</v-icon>&nbsp;&nbsp;{{ $t('page.my-meeting.meeting-reserve') }}
    </v-btn> -->
  </v-layout>
</template>
<script>
import Util from '@/util';
import moment from 'moment';

let addAllData = [{ name: 'All', _id: '9999' }];
let addAllDataFloor = [{ name: 'All', floor: '9999' }];
let addAllDataCustomType = { name: '모든 회의 유형', value: '9999' };

export default {
  props: {
    groupChange: { type: Function },
    buildingChange: { type: Function },
    floorChange: { type: Function },
    isAddAll: { type: Boolean },
    isGroupsView: { type: Boolean, default: true },
    isBuildingsView: { type: Boolean, default: true },
    isFloorView: { type: Boolean, default: true },
    changedGroupId: { type: String, default: '' },
    type: { type: String, default: 'video' },
    viewType: { type: String, default: 'calendar' }
  },
  data: function () {
    return {
      group: this.isAddAll ? addAllData : [],
      building: [{ name: 'All', _id: '9999' }],
      floor: addAllDataFloor,
      buildingList: null,
      customTypeList: [],
      selectedGroup: null,
      selectedBuilding: null,
      selectedFloor: null,
      selectedRooms: null,
      selectedCustomType: '9999',
      rooms: null,
      startDate: moment().format('YYYY-MM-DD'),
      endDate: moment().add(1, 'week').format('YYYY-MM-DD'),
      menu: false,
      menu1: false,
    };
  },
  watch: {
    changedGroupId (val) {
      if (val !== '') {
        this.selectedGroup = this.changedGroupId;
        this.changedGroup(this.selectedGroup);
      }
    },
    startDate (val) {
      if (val && val !== '') {
        this.changedStartDate(val);
      }
    },
    endDate (val) {
      if (val && val !== '') {
        this.changedEndDate(val);
      }
    }
  },
  async mounted () {
    this.init();
    await this.getRooms();
    await this.getBuildings();
    await this.getCompanyGroup();
  },
  methods: {
    init () {
      this.customTypeList = [];
      this.customTypeList.push(addAllDataCustomType);
      this.customTypeList.push({ name: this.$t('page.meeting-reserve.in-general'), value: 'inGeneral' });
      this.customTypeList.push({ name: this.$t('page.meeting-reserve.in-important'), value: 'inImportant' });
      this.customTypeList.push({ name: this.$t('page.meeting-reserve.out-general'), value: 'outGeneral' });
      this.customTypeList.push({ name: this.$t('page.meeting-reserve.out-important'), value: 'outImportant' });
    },
    async getCompanyGroup () {
      await this.$http.get('/api/v1/company/groups', { params: { type: 'room' }}).then((response) => {
        this.group = this.group.concat(response.data);
        let index = response.data.findIndex(group => group._id === this.$store.state.user.company);
        if (this.$store.state.user.company === '' || index < 0) {
          this.selectedGroup = this.group[0].length > 0 ? this.group[0]._id : '';
          return;
        }
        this.selectedGroup = this.$store.state.user.company;
        // 해당그룹만 표시
        // this.group = this.group.filter(x => x._id === this.selectedGroup);
        this.changedGroup(this.selectedGroup);
      }).catch(error => {
        console.log(error);
      });
    },
    async getBuildings () {
      await this.$http.get('/api/v1/building', { params: { type: 'room' }}).then((response) => {
        this.buildingList = response.data;
      }).catch(error => {
        console.log(error);
      });
    },
    async getRooms () {
      await this.$http.get('/api/v1/rooms').then((response) => {
        this.rooms = response.data;
        // this.selectedRooms = this.rooms;
      }).catch(error => {
        console.log(error);
      });
    },
    changedGroup (groupId) {
      console.log(`changedGroup`, this.endDate);
      this.selectedGroup = groupId;

      let filteredBuilding = this.buildingList.filter(elem => elem.groupId._id.toString() === groupId.toString());
      this.building = [];
      this.building = this.building.concat(filteredBuilding);
      if (this.$store.state.user.location === undefined || this.$store.state.user.location === '') {
        this.selectedBuilding = this.building.length > 0 ? this.building[0]._id : '';
      } else {
        this.selectedBuilding = this.$store.state.user.location;
      }

      let sortedDistinctFloor = this.getFloorList(this.selectedBuilding);
      this.floor = addAllDataFloor;
      this.floor = this.floor.concat(sortedDistinctFloor);

      this.selectedFloor = this.floor[0].floor;
      if (this.$store.state.user.floor !== undefined && this.$store.state.user.floor !== null && this.$store.state.user.floor !== '') {
        this.selectedFloor = this.$store.state.user.floor;
      }
      // 두산버전
      // this.groupChange(groupId, this.selectedBuilding);
    },
    changedBuilding (buildingId) {
      console.log(`changedBuilding`, this.endDate);
      this.selectedBuilding = buildingId;
      this.selectedFloor = '9999';
      this.selectedFloor = this.floor[0].floor;

      let sortedDistinctFloor = this.getFloorList(buildingId);

      this.floor = addAllDataFloor;
      this.floor = this.floor.concat(sortedDistinctFloor);

      // this.buildingChange(buildingId);
      // 두산버전
      this.groupChange(this.selectedGroup, this.selectedBuilding, null, this.customTypeValue, this.startDate, this.endDate);
    },
    changedFloor (floorValue) {
      this.groupChange(this.selectedGroup, this.selectedBuilding, floorValue, this.customTypeValue, this.startDate, this.endDate);
    },
    changedCustomType (customTypeValue) {
      this.groupChange(this.selectedGroup, this.selectedBuilding, this.floorValue, customTypeValue, this.startDate, this.endDate);
    },
    changedStartDate (startDate) {
      console.log(`changedStartDate`, startDate);
      this.groupChange(this.selectedGroup, this.selectedBuilding, this.floorValue, this.customTypeValue, startDate, this.endDate);
    },
    changedEndDate (endDate) {
      console.log(`changedEndDate`, endDate);
      this.groupChange(this.selectedGroup, this.selectedBuilding, this.floorValue, this.customTypeValue, this.startDate, endDate);
    },
    reserveMeeting () {
      this.$router.push({ name: 'Reserve', query: { type: this.type }});
    },
    getFloorList () {
      
      let buildingRooms = this.rooms.filter(elem => elem.buildingId === this.selectedBuilding);
      console.log(buildingRooms);
      // let distinctFloor = [...new Set(buildingRooms.filter(elem => elem.floor !== null && isNaN(elem.floor) === false).map((elem) => {
      //   return {
      //     name: elem.floor.length === 1 ? '0' + Util.numberToFloorText(elem.floor) + this.$t('util.floor') : Util.numberToFloorText(elem.floor) + this.$t('util.floor'),
      //     floor: elem.floor.length === 1 ? '0' + elem.floor : elem.floor
      //   };
      // }))];
      let distinctFloorNotNumber = [...new Set(buildingRooms.filter(elem => elem.floor !== null).map((elem) => {
        return {
          name: String(elem.floor),
          floor: String(elem.floor)
        };
      }))];
      console.log(distinctFloorNotNumber);
      return Util.sortString(distinctFloorNotNumber, 'floor');
    },
    allowedStartDates (d) {
      return moment(d).format('YYYY-MM-DD') >= moment().format('YYYY-MM-DD');
    },
    allowedEndDates (d) {
      return moment(d).format('YYYY-MM-DD') >= moment(this.startDate).format('YYYY-MM-DD');
    }
    // addImmediateMeeting () {
    //   let params = {
    //     isImmediate: true
    //   };
    //   this.$router.push({ path: '/reserve', query: { meetingInfo: JSON.stringify(params) }});
    // }
  }
};
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/schedules/Filter.vue